import { Entry } from "../../../model/entry/Entry";
import isFunction from "lodash/isFunction";
import { AtiraToast } from "../../../utils/AtiraToast";
import isEmpty from "lodash/isEmpty";

const ERROR_NAME = "entries.duplicates-found";

/** This will handle duplicate entry errors during create or edit operations
 *  AND it will show the toast for other types of errors.
 */
export const entryCreateEditDuplicateErrorHandler = (
  config: {
    error: any;
    keepCurrentModalOpen?: boolean;
  },
  functions: {
    setModal: ATVoidFunction<boolean>;
    setActionModal?: ATVoidFunction<boolean>;
    setEntries: (entries: Entry[]) => void;
    setGroups: (groups: Record<string, Entry[]>) => void;
  },
) => {
  const { error, keepCurrentModalOpen } = config;
  const { setModal, setActionModal, setEntries, setGroups } = functions;

  const serverThrewConditions =
    error?.response?.data?.fields?.[0]?.params?.customErrorName ===
      ERROR_NAME && error?.response?.data?.fields?.[0]?.params?.entries?.length;
  const serverReturnedConditions =
    error?.response?.data?.params?.customErrorName === ERROR_NAME &&
    error?.response?.data?.params?.entries?.length;

  const entries = serverThrewConditions
    ? error?.response?.data?.fields?.[0]?.params?.entries || []
    : error?.response?.data?.params?.entries || [];
  const groups = serverThrewConditions
    ? error?.response?.data?.fields?.[0]?.params?.groups || {}
    : error?.response?.data?.params?.groups || {};

  if (serverThrewConditions || serverReturnedConditions) {
    setModal(true);

    if (!keepCurrentModalOpen && isFunction(setActionModal)) {
      setActionModal(false);
    }

    setEntries(entries);

    if (setGroups && !isEmpty(groups)) {
      setGroups(groups);
    }
  } else {
    AtiraToast.apiError(error);
  }
};
